import * as React from 'react';
import { Table, Pagination, Divider } from 'antd';
import { resolve } from 'inversify-react';

import { FormatService } from 'src/core/services/format.service';
import PropertyRouter from 'src/app/general/audit/parts/property-router';
import { DataTableView, ToolbarVisibility } from 'src/core/ui/data-table.view';
import { DataLocalService } from "src/core/services/data-local.service";

interface IProps {
	onPageChange: (index: number) => void;
	data: { items: any[], pageIndex: number, pageSize: number, total: number }
	extraDiscrminator?: (name: string, value: any) => any;
}

interface ViewProps {
	data: any[]
	extraDiscrminator?: (name: string, value: any) => any;
}

class ChangesView extends React.Component<ViewProps, {}>{

	public render() {
		const columns = [
			{
				key: 'Name',
				title: 'Property',
				dataIndex: 'Name',
				width: 100
			},
			{
				key: 'before',
				title: 'Before',
				render: (text, record) => {
					return <PropertyRouter extraDiscriminator={this.props.extraDiscrminator} name={record.Name} value={record.Before} />;
				}
			},
			{
				key: 'after',
				title: 'After',
				render: (text, record) => {
					return <PropertyRouter extraDiscriminator={this.props.extraDiscrminator} name={record.Name} value={record.After} />;
				}
			}
		];

		return <Table columns={columns} dataSource={this.props.data} rowKey="Name" />;
	}
}

interface IDescriptionRendererProps {
	record: any;
}

class QuoteDescriptionRenderer extends React.Component<IDescriptionRendererProps, {}>{ }
class QuoteEntryDescriptionRenderer extends React.Component<IDescriptionRendererProps, {}>{ }
class QuotePaxDescriptionRenderer extends React.Component<IDescriptionRendererProps, {}>{ }
class TaskDescriptionRenderer extends React.Component<IDescriptionRendererProps, {}>{ }
class PaymentDescriptionRenderer extends React.Component<IDescriptionRendererProps, {}>{ }
class DocumentDescriptionRenderer extends React.Component<IDescriptionRendererProps, {}>{ }

export default class HistoryViewTable extends React.Component<IProps, {}>{

	@resolve
	private formatService: FormatService;

	private buildEventDescription(record: any) {
		const statusChanged = record.Changes.find((change: any) => change.Name == "Status");
		if (statusChanged) {
			return `${record.ModelType} ${this.props.extraDiscrminator("Status", statusChanged.After)}`;
		}
		else return "";
	}

	private buildGeneralDescription(record: any) {
		// switch (record.ModelType) {
		// 	case 'Quote':
		// 		return <QuoteDescriptionRenderer record={record}/>;
		// 	case 'QuoteEntry':
		// 		return <QuoteEntryDescriptionRenderer record={record}/>;
		// 	case 'QuotePax':
		// 		return <QuotePaxDescriptionRenderer record={record}/>;
		// 	case 'Task':
		// 		return <TaskDescriptionRenderer record={record}/>;
		// 	case 'Payment':
		// 		return <PaymentDescriptionRenderer record={record}/>;
		// 	case 'Document':
		// 		return <DocumentDescriptionRenderer record={record}/>;
		// 	default:
		// 		return undefined;
		// }
		return "Substitute this with the proper component";
	}

	private getColumns() {
		return [
			{
				key: "date",
				dataIndex: "Date",
				title: "Event Date",
				render: (text, record: any, index: number) => this.formatService.toString("small-date-time", text, 'utc'),
			},
			{
				key: "modifiedBy",
				dataIndex: "ModifiedBy",
				title: "Modified By"
			},
			{
				key: "event",
				title: "Event",
				render: (text, record: any, index: number) => this.buildEventDescription(record),
			},
			{
				key: "description",
				title: "Description",
				render: (text, record: any, index: number) => this.buildGeneralDescription(record),
			}
		];
	}

	public render() {
		const { data, extraDiscrminator, onPageChange } = this.props;
		const dataSet: any = new DataLocalService(data.items, 10);

		return (
			<div>
				<DataTableView
					rowKey={this.getKey}
					columns={this.getColumns()}
					model={dataSet}
					setBusy={e => { }}
					hideToolbar={ToolbarVisibility.hideModifyButtons | ToolbarVisibility.hidePagination}
					expandedRowRender={(record: any) => <ChangesView extraDiscrminator={extraDiscrminator} data={record.Changes} key={record.key} />}
				/>
				<Divider>
					<Pagination
						onChange={page => onPageChange(page - 1)}
						current={data.pageIndex + 1}
						total={data.total}
						pageSize={data.pageSize}
					/>
				</Divider>
			</div>
		);
	}

	private getKey = (record: any): string => {
		return record.EntityId.join("-") + "-" + record.Date;
	}
}



// WEBPACK FOOTER //
// ./src/app/general/audit/parts/general-history.view.tsx